import React, { useState, useEffect } from "react";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  updateDoc,
  doc,
  serverTimestamp,
} from "firebase/firestore";
import { db } from "../firebase/firebase";

import Sidebar from "../components/layout/Sidebar";
import Topbar from "../components/layout/Topbar";

import "./UpdatesFeed.css";

export default function UpdatesFeed() {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [active, setActive] = useState(true);
  const [updates, setUpdates] = useState([]);
  const [editingId, setEditingId] = useState(null);

  // =============================
  // 🔥 Carregar Updates
  // =============================
  const loadUpdates = async () => {
    const snap = await getDocs(collection(db, "updates_feed"));
    const list = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    list.sort((a, b) => b.createdAt?.seconds - a.createdAt?.seconds);
    setUpdates(list);
  };

  useEffect(() => {
    loadUpdates();
  }, []);

  // =============================
  // 🔥 Salvar Update
  // =============================
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (title.trim() === "" || message.trim() === "") {
      alert("Preencha todos os campos.");
      return;
    }

    if (editingId) {
      // Atualizar
      const ref = doc(db, "updates_feed", editingId);
      await updateDoc(ref, {
        title,
        message,
        active,
      });

      setEditingId(null);
    } else {
      // Criar novo
      await addDoc(collection(db, "updates_feed"), {
        title,
        message,
        active,
        createdAt: serverTimestamp(),
      });
    }

    setTitle("");
    setMessage("");
    setActive(true);

    loadUpdates();
  };

  // =============================
  // 🗑️ Excluir
  // =============================
  const handleDelete = async (id) => {
    if (!window.confirm("Deseja realmente excluir este update?")) return;

    await deleteDoc(doc(db, "updates_feed", id));
    loadUpdates();
  };

  // =============================
  // ✏️ Editar
  // =============================
  const handleEdit = (item) => {
    setEditingId(item.id);
    setTitle(item.title);
    setMessage(item.message);
    setActive(item.active);
  };

  return (
    <div className="page-wrapper">
      {/* Sidebar fixa */}
      <Sidebar />

      {/* Conteúdo da página */}
      <div className="page-content">
        <Topbar />

        <div className="updates-container">
          <h2>Feed de Updates</h2>

          {/* =============================
              FORMULÁRIO
          ============================= */}
          <form className="updates-form" onSubmit={handleSubmit}>
            <h3>{editingId ? "Editar Update" : "Criar Novo Update"}</h3>

            <label>Título</label>
            <input
              type="text"
              placeholder="Ex: Novo recurso liberado!"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />

            <label>Mensagem</label>
            <textarea
              placeholder="Descreva o update…"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            ></textarea>

            <label className="checkbox-line">
              <input
                type="checkbox"
                checked={active}
                onChange={(e) => setActive(e.target.checked)}
              />
              <span>Ativo</span>
            </label>

            <button className="btn-submit" type="submit">
              {editingId ? "Salvar Alterações" : "Publicar Update"}
            </button>
          </form>

          {/* =============================
              LISTAGEM
          ============================= */}
          <div className="updates-list">
            <h3>Updates Cadastrados</h3>

            {updates.length === 0 ? (
              <p className="empty-text">Nenhum update cadastrado ainda.</p>
            ) : (
              updates.map((item) => (
                <div key={item.id} className="update-card">
                  <div className="update-info">
                    <h4>{item.title}</h4>
                    <p>{item.message}</p>

                    <span
                      className={`status-badge ${
                        item.active ? "active" : "inactive"
                      }`}
                    >
                      {item.active ? "Ativo" : "Inativo"}
                    </span>

                    <p className="date">
                      {item.createdAt?.seconds
                        ? new Date(item.createdAt.seconds * 1000).toLocaleString()
                        : "—"}
                    </p>
                  </div>

                  <div className="update-actions">
                    <button onClick={() => handleEdit(item)} className="btn-edit">
                      Editar
                    </button>
                    <button
                      onClick={() => handleDelete(item.id)}
                      className="btn-delete"
                    >
                      Excluir
                    </button>
                  </div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
  